export default __webpack_public_path__ + "static/satisfaction-guarantee-f3e672a3d4a3ae838dbca8033a850eab.png";